import * as React from "react";

const styles = require("./styles.module.scss");

const WorksheetAsLink: React.SFC<any> = ({
  id,
  onClickLink,
  onClickAdd,
  readOnly,
}) => {
  if (id) {
    return (
      <div onClick={() => onClickLink(id)} className={styles.wsLink}>
        {id}
      </div>
    );
  }
  if (readOnly) {
    return null;
  }
  return (
    <i
      onClick={onClickAdd}
      className={`${styles.wsLinkButton} fa fa-plus-circle`}
    />
  );
};

export default WorksheetAsLink;
